import { RouteProp, useRoute } from "@react-navigation/native";
import { useSetAtom } from "jotai";
import { Suspense, useEffect } from "react";
import { StatusBar } from "react-native";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { ClubStackNavigatorParamList } from "../../../../navigators/ClubNavigator";
import { isMoveBooking_atom } from "../MultiSlotBookingScreen/atoms";
import {
  MultiSlotBookingScreenRenderer,
  MultiSlotBookingScreenRendererQueryString,
} from "./MultiSlotBookingScreenRenderer";
import { MultiSlotBookingScreenRendererQuery } from "./__generated__/MultiSlotBookingScreenRendererQuery.graphql";
import { getCurrentDateStringOrDefaultToToday } from "./utils";

export const MultiSlotBookingScreen = () => {
  const [queryRef, loadQuery] =
    useQueryLoader<MultiSlotBookingScreenRendererQuery>(
      MultiSlotBookingScreenRendererQueryString
    );
  const setIsMoveBooking = useSetAtom(isMoveBooking_atom);

  const route = useRoute<RouteProp<ClubStackNavigatorParamList, "Agenda">>();
  const date = getCurrentDateStringOrDefaultToToday(route?.params?.date);

  useEffect(() => {
    loadQuery({ date });
  }, [loadQuery, date]);

  useEffect(() => {
    setIsMoveBooking(false);
  }, [setIsMoveBooking]);

  return (
    <Box flex={1} safeAreaTop bg="surface-primary">
      <StatusBar barStyle="dark-content" />
      <Suspense fallback={<Loader />}>
        {queryRef && <MultiSlotBookingScreenRenderer queryRef={queryRef} />}
      </Suspense>
    </Box>
  );
};
